/**
 * Turnstile-Adapter
 * Stellt window.theme.turnstile.getToken({ action, container }) bereit.
 *
 * Cloudflare-Turnstile-Token sind EINMAL gültig (der Server verbraucht sie).
 * Für mehrere Aktionen (z. B. "upload_child_photo" UND danach "create_preview")
 * braucht man pro Aktion einen frischen Token.
 *
 * Strategie (robust für Managed/Non-interactive/Invisible):
 *   - Widget wird in einen SICHTBAREN Container gerendert ([data-pixa-turnstile]),
 *     damit eine evtl. interaktive Challenge gelöst werden kann.
 *   - Nach render() wird execute() aufgerufen (in try/catch: manche Modi laufen
 *     bereits automatisch -> "already executing" ist dann harmlos).
 *   - Folge-Token derselben Action: reset() + execute().
 *   - Andere Action: Widget neu rendern.
 *   - error-callback liefert einen Fehlercode -> wird in die Meldung übernommen.
 *
 * Voraussetzung: Cloudflare-Lib geladen, window.theme.turnstile.siteKey gesetzt.
 */
(function () {
  window.theme = window.theme || {};
  var cfg = (window.theme.turnstile = window.theme.turnstile || {});
  if (cfg.errorMessage == null) {
    cfg.errorMessage = "Bitte schließe die Sicherheitsprüfung ab und versuche es erneut.";
  }

  // Genau EIN Widget. { id, holder, action, cb }
  var current = null;

  function ready() {
    return new Promise(function (resolve, reject) {
      if (window.turnstile && window.turnstile.render) return resolve();
      var waited = 0;
      var iv = setInterval(function () {
        if (window.turnstile && window.turnstile.render) {
          clearInterval(iv);
          resolve();
        } else if ((waited += 100) > 10000) {
          clearInterval(iv);
          reject(new Error("Turnstile konnte nicht geladen werden."));
        }
      }, 100);
    });
  }

  function resolveContainer(opts) {
    if (opts.container instanceof HTMLElement) return opts.container;
    var box = document.querySelector("[data-pixa-turnstile]");
    if (box) return box;
    var holder = document.createElement("div");
    holder.style.cssText =
      "position:fixed;width:0;height:0;overflow:hidden;left:-9999px;top:-9999px;";
    document.body.appendChild(holder);
    return holder;
  }

  function boxOf(el) {
    return el && el.closest ? (el.closest("[data-pixa-turnstile]") || el) : el;
  }
  function showBox(el) {
    var box = boxOf(el);
    if (box && box.removeAttribute) box.removeAttribute("hidden");
  }
  function hideBox(el) {
    var box = boxOf(el);
    if (box && box.setAttribute && box.hasAttribute("data-pixa-turnstile")) {
      box.setAttribute("hidden", "");
    }
  }

  function tryExecute(id) {
    try { window.turnstile.execute(id); } catch (e) { /* z. B. "already executing" -> egal */ }
  }

  function teardown() {
    if (!current) return;
    try { if (current.id !== undefined) window.turnstile.remove(current.id); } catch (e) {}
    try {
      if (current.holder && !current.holder.hasAttribute("data-pixa-turnstile") && current.holder.parentNode) {
        current.holder.parentNode.removeChild(current.holder);
      } else if (current.holder) {
        current.holder.innerHTML = "";
      }
    } catch (e) {}
    current = null;
  }

  cfg.getToken = function (opts) {
    opts = opts || {};
    if (cfg.enabled === false || !cfg.siteKey) return Promise.resolve("");
    var action = opts.action || "";

    return ready().then(function () {
      return new Promise(function (resolve, reject) {
        var settled = false;
        var timer = setTimeout(function () {
          finish(null, new Error("Turnstile-Timeout"));
        }, 30000);

        function finish(token, err) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          if (current && current.holder) hideBox(current.holder);
          if (err) reject(err);
          else resolve(token || "");
        }

        function renderFresh() {
          var holder = resolveContainer(opts);
          showBox(holder);
          current = { holder: holder, action: action, cb: finish };
          current.id = window.turnstile.render(holder, {
            sitekey: cfg.siteKey,
            action: action,
            retry: "auto",
            callback: function (token) { if (current && current.cb) current.cb(token, null); },
            "error-callback": function (code) {
              if (current && current.cb) current.cb(null, new Error("Turnstile-Fehler (" + (code || "?") + ")"));
              return true; // Fehler behandelt -> Widget nicht in Dauer-Retry
            },
            "timeout-callback": function () { if (current && current.cb) current.cb(null, new Error("Turnstile-Timeout (challenge)")); },
            "expired-callback": function () { /* nächster getToken nutzt reset() */ },
          });
          tryExecute(current.id);
        }

        // Gleiche Action + vorhandenes Widget -> reset() + execute() = frischer Token
        if (current && current.id !== undefined && current.action === action) {
          current.cb = finish;
          showBox(current.holder);
          try {
            window.turnstile.reset(current.id);
            tryExecute(current.id);
          } catch (e) {
            teardown();
            try { renderFresh(); } catch (e2) { finish(null, e2); }
          }
          return;
        }

        teardown();
        try { renderFresh(); } catch (e) { finish(null, e); }
      });
    });
  };
})();
